"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _selectn = require("selectn");

var _selectn2 = _interopRequireDefault(_selectn);

var _lodash = require("lodash");

var _StatusWrapper = require("../../../components/StatusWrapper");

var _StatusWrapper2 = _interopRequireDefault(_StatusWrapper);

var _reactIntl = require("react-intl");

var _connectRouter = require("../../../decorators/connectRouter");

var _connectRouter2 = _interopRequireDefault(_connectRouter);

var _actions = require("../../reducers/reportDetail/actions");

var reportDetailActions = _interopRequireWildcard(_actions);

var _ReportDetailSidebar = require("./ReportDetailSidebar");

var _ReportDetailSidebar2 = _interopRequireDefault(_ReportDetailSidebar);

var _reactCssModules = require("react-css-modules");

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _ReportDetailTypeContent = require("./ReportDetailTypeContent");

var _ReportDetailTypeContent2 = _interopRequireDefault(_ReportDetailTypeContent);

var _ReportDetailTypeInstance = require("./ReportDetailTypeInstance");

var _ReportDetailTypeInstance2 = _interopRequireDefault(_ReportDetailTypeInstance);

var _ReportDetailReopenList = require("./ReportDetailReopenList");

var _ReportDetailReopenList2 = _interopRequireDefault(_ReportDetailReopenList);

var _ReportDetailSteps = require("./ReportDetailSteps");

var _ReportDetailSteps2 = _interopRequireDefault(_ReportDetailSteps);

var _mapToState = require("../../mapToState");

var _reportUtils = require("../../reducers/reports/reportUtils");

var reportUtils = _interopRequireWildcard(_reportUtils);

var _reactRedux = require("react-redux");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var styles = require("./ReportDetailContainer.less");

var ReportDetailContainer = function (_React$Component) {
    _inherits(ReportDetailContainer, _React$Component);

    function ReportDetailContainer(props) {
        _classCallCheck(this, ReportDetailContainer);

        var _this2 = _possibleConstructorReturn(this, Object.getPrototypeOf(ReportDetailContainer).call(this, props));

        _this2.routerWillLeave = function (nextLocation) {
            // return false to prevent a transition w/o prompting the user,
            // or return a string to allow the user to decide:
            if (_this2.props.reportDetail.isSynchronized === false && (0, _lodash.isString)(nextLocation.pathname) && nextLocation.pathname.indexOf("reports/detail/" + _this2.props.reportDetail.selectedReport.uid) === -1) {
                var confirmed = confirm(_this2.props.intl.formatMessage({ id: "reportDetail.confirmDismissReportChanges" }));
                if (!confirmed) {
                    return false;
                }
            }
            return true;
        };
        _this2.loadAndSelectReportDetailsIfNeeded = function (props) {
            var uid = (0, _selectn2.default)("uid", props.params);
            if (uid) {
                (0, _mapToState.mapToState)(function () {
                    return _this2;
                }, function () {
                    return props.dispatch(reportDetailActions.selectReportById(uid)).then(function (value) {
                        return props.dispatch(reportDetailActions.loadContingentOfCurrentReportDefinition());
                    });
                });
            }
        };
        _this2.dismissError = function () {
            _this2.state.dismissError();
            _this2.props.dispatch(reportDetailActions.dismissUploadError());
        };
        _this2.onSaveButtonPressed = function () {
            var _this = _this2;
            var detailSteps = (0, _selectn2.default)("refs.detailSteps", _this);
            _this2.state.onSaveButtonPressed();
        };
        _this2.state = {
            isLoading: false,
            onSaveButtonPressed: null,
            showErrors: false
        };
        return _this2;
    }

    _createClass(ReportDetailContainer, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var _props = this.props;
            var router = _props.router;
            var route = _props.route;

            this.loadAndSelectReportDetailsIfNeeded(this.props);
            // reset leave hook
            router.setRouteLeaveHook(route, this.routerWillLeave);
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            this.props.dispatch(reportDetailActions.reset());
        }
    }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps, nextState) {
            var nextUid = (0, _selectn2.default)("uid", nextProps.params);
            var currentUid = (0, _selectn2.default)("uid", this.props.params);
            if (currentUid !== nextUid) {
                this.loadAndSelectReportDetailsIfNeeded(nextProps);
                nextProps.router.setRouteLeaveHook(nextProps.route, this.routerWillLeave);
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _this3 = this;

            var content = null;
            var type = this.props.params.type;
            var dataUid = this.props.params.definitionUid;
            content = React.createElement(_ReportDetailSteps2.default, { showErrors: this.state.showErrors, stepUid: dataUid });
            var uploadRunning = (0, _selectn2.default)("pending", this.props.reportDetail.saveReportDataPromiseState);
            var uploadError = (0, _selectn2.default)("reason", this.props.reportDetail.saveReportDataPromiseState);
            var selectedReport = this.props.reportDetail.selectedReport;
            var selectedReportDefinition = this.props.reportDetail.selectedReportDefinition;
            if (dataUid && selectedReport && type && selectedReportDefinition) {
                var reportData = reportUtils.findReportDataForUid(dataUid, selectedReport, selectedReportDefinition, this.props.reportDetail.reportData);
                if (type === "objects" || type === "issues" || type === "items" || type === "reopenReasonsList") {
                    if (type === "reopenReasonsList") {
                        content = React.createElement(_ReportDetailReopenList2.default, null);
                    } else {
                        if ((0, _lodash.isString)(this.props.params.instanceUid)) {
                            content = React.createElement(_ReportDetailTypeInstance2.default, { currentReportData: reportData, instanceUid: this.props.params.instanceUid });
                        } else {
                            content = React.createElement(_ReportDetailTypeContent2.default, { currentReportData: reportData });
                        }
                    }
                } else if (type === "steps") {
                    content = React.createElement(_ReportDetailSteps2.default, { showErrors: this.state.showErrors, stepUid: dataUid });
                }
            }
            return React.createElement("div", { styleName: "page" }, React.createElement(_StatusWrapper2.default, { error: this.state.error || uploadError, isLoading: this.state.isLoading || uploadRunning, className: styles["status-wrapper"], onDismissError: this.dismissError }, React.createElement("div", { styleName: "sidebar" }, React.createElement(_ReportDetailSidebar2.default, { showErrors: this.state.showErrors, onShowErrorsButtonPressed: function onShowErrorsButtonPressed() {
                    var newState = _this3.state;newState.showErrors = !_this3.state.showErrors;_this3.setState(newState);
                } })), content));
        }
    }]);

    return ReportDetailContainer;
}(React.Component);
ReportDetailContainer = __decorate([_reactIntl.injectIntl, _connectRouter2.default, (0, _reactRedux.connect)(function (state) {
    return {
        auth: state.auth,
        user: state.user,
        reportDetail: state.reportDetail
    };
}), (0, _reactCssModules2.default)(styles)], ReportDetailContainer);
exports.default = ReportDetailContainer;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/containers/reportDetail/ReportDetailContainer.tsx
 ** module id = 631
 ** module chunks = 0
 **/